

import { useQuery } from "@tanstack/react-query";
import { abonosXOp  } from "../../../services";






// export const useOPXID = (id) => {
//     const { data, isLoading } = useQuery({
//         queryKey: ['op-id', { id }], 
//         queryFn: () => opPorID(id),
//         enabled: !!id,
//     });

//     return { data, isLoading }
// }




export const useAbonosXOp = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['abonosxop', { id }], 
        queryFn: () => abonosXOp(id),
    });
    
    return { data, isLoading }
}
